<template>
    <legal-document-layout title="Terms of Service" :version="version">
        <div v-if="terms" v-html="terms" class="prose prose-sm max-w-none"></div>
        <p v-else class="text-sm text-red-600">
            Terms of Service failed to load. Please refresh the page or contact support.
        </p>
    </legal-document-layout>
</template>

<script>
import LegalDocumentLayout from '@/Layouts/LegalDocumentLayout.vue';

export default {
    name: 'TermsOfService',
    components: {
        LegalDocumentLayout,
    },
    props: {
        terms: { type: String, default: null },
        version: { type: String, default: null },
    },
};
</script>
